import type { ServicesUsageResponse } from "@/types/analytics-services";
import {
  downloadAnalyticsExport,
  type AnalyticsExportFormat,
  type AnalyticsExportTableSection,
} from "../../utils/analyticsFileExport";
import type { TopServiceRow } from "./mockData";

function buildUsageSection(
  usage: ServicesUsageResponse | undefined,
  totalGuests: number,
): AnalyticsExportTableSection {
  if (!usage) {
    return {
      title: "Guest Usage",
      headers: ["Name", "Guests Used", "Guest Used %"],
      rows: [],
    };
  }

  if (usage.category === "ALL") {
    return {
      title: "Guest Usage by Category",
      headers: ["Category", "Guests Used", "Guest Used %", "Total Guests"],
      rows: usage.byCategory.map((row) => [
        row.category,
        row.guestsUsed,
        row.guestUsedPercent ?? "",
        totalGuests,
      ]),
    };
  }

  return {
    title: "Guest Usage by Service",
    headers: ["Service", "Guests Used", "Guest Used %", "Total Guests"],
    rows: usage.byService.map((row) => [
      row.service.name,
      row.guestsUsed,
      row.guestUsedPercent ?? "",
      totalGuests,
    ]),
  };
}

function buildTopServicesSection(
  rows: TopServiceRow[],
): AnalyticsExportTableSection {
  return {
    title: "Top Services",
    headers: ["Rank", "Service", "Bookings", "Guest Used %", "Revenue"],
    rows: rows.map((row) => [
      row.rate,
      row.name,
      row.bookings,
      row.guestsUsedPercent,
      row.revenue,
    ]),
  };
}

export function downloadServicesTabExport(params: {
  format: AnalyticsExportFormat;
  hotelId: string;
  from: string;
  to: string;
  topServices: TopServiceRow[];
  usage: ServicesUsageResponse | undefined;
  totalGuests: number;
}): boolean {
  const sections = [
    buildTopServicesSection(params.topServices),
    buildUsageSection(params.usage, params.totalGuests),
  ];

  if (sections.every((section) => section.rows.length === 0)) {
    return false;
  }

  downloadAnalyticsExport(
    params.format,
    sections,
    `analytics-services-tab-${params.hotelId}-${params.from}-${params.to}`,
  );
  return true;
}
